import {s, lazy, trigger, filter} from './lang.js';
import {doc} from './documentation.js';

doc(
    "delay", 
    {
        rate: "The rate in 1/32th notes that it repeats",
        repeats: "Number of times it repeats"
    },
    "Simple midi delay function"
);

export const delay = (rate=1,repeats=1) => {
    var history = [];
    // every function should accept these 3 arguments in order
    // the user doesn't know about it, all they know is to write
    // delay(1,2) and everything else will be handled for them
    return (stepData, stepNumber, time) => {
        let trig = stepData && {stepData, stepNumber, time, repeats: lazy(repeats, stepData, stepNumber, time)};

        let _rate = lazy(rate, stepData || history[0], stepNumber, time);
        // check the history for events that still need to go
        let triggers = [];
        let _history = [];
        for (let t of history) {
            let elapsed = Math.abs(stepNumber - t.stepNumber);
            if (elapsed % _rate === 0) {
                t.repeats--;
                triggers.push({stepData: t.stepData, time, stepNumber});
            }
            if (t.repeats > 0) {
                _history.push(t);
            }
        }
        history = _history;
        if (trig) {
            history.push(trig);
        }

        if (!trig && triggers.length === 0) {
            return filter(false);
        }
        if (trig) {
            triggers = [... triggers, trig];
        }
        if (triggers.length > 0) {
            let x = trigger(triggers);
            return x;
        } else {
            return filter(false);
        }
    };
};
